import React, { useRef } from "react";
import UiPanel from "./UiPanel";

function CenterUI({ config }) {
  const hideUI = config.hideUI || false;
  const iframeRef = useRef(null);

  return (
    <div style={{justifyContent:'center', alignItems:'center', display:'flex'}}>
      <div className="mainElem">
        <div className="CenterUI">
          {hideUI ? <></> : <UiPanel iframeRef={iframeRef} />}
            <iframe
              ref={iframeRef}
              src={config.initalUrl}
              className="IframeComponent"
              frameBorder="0"
              allowFullScreen
              title="App iframe"
            ></iframe>
        </div>
      </div>
    </div>
  );
}

export default CenterUI;
